import * as o from "react";
import { d as r } from "./styled-38387a7e.js";
import { u as t } from "./useTheme-efe1290c.js";
function s() {
  const e = t(r);
  return process.env.NODE_ENV !== "production" && o.useDebugValue(e), e;
}
export {
  s as u
};
